import {Component, OnInit} from '@angular/core';

import {AuthentificationService} from './authentification.service';

const MENU_ITEMS = [
    {
        title: 'Entrepôts',
        ico_url: './img/ico_articles.png',
        link: "admin/warehouse",
        children: <any>[],
    },
    {
        title: 'Etat de stocks',
        ico_url: './img/ico_articles.png',
        link: "admin/stock-availibility",
        children: <any>[],
    },
    //    {
    //        title: "Gestion codes d'actions",
    //        ico_url: './img/ico_articles.png',
    //        link: "admin/codes",
    //        children: <any>[],
    //    },
    {
        title: 'Utilisateur',
        ico_url: './img/ico_aide.png',
        link: 'super-users',
        children: [
            {
                title: 'Se déconnecter',
                link: "admin"
            }

        ],
    }

];

@Component({
    selector: 'left-menu-sudo',
    styleUrls: ['./styles/left-menu.component.css'],
    templateUrl: './templates/left-menu.component.html',
    providers: [AuthentificationService]
})


export class LeftMenuSudoComponent implements OnInit {
    name = 'Left Menu';
    current_item = 0;
    menu_items = MENU_ITEMS;

    constructor(private authentification_service: AuthentificationService) {

    }

    toggle(idx: number): void {
        if (this.current_item === idx) {
            // Folding
            this.current_item = -1;
        } else {
            // Expanding
            this.current_item = idx;
        }
    };

    IsUserLogOut(action: string): void {
        //console.log(action);
        if (action === "admin") {
            //LOGout
            this.authentification_service.superLogOut().then(result => {console.log(result)});
        }
    }

    ngOnInit(): void {

    }
}



// WEBPACK FOOTER //
// ./src/app/left-menu-sudo.component.ts